import * as zod from 'zod';

export type TimeSelectionFormData = { time: string };
export const MaskTime = (value: string) => {
  const cleanedValue = value.trim().replace(/\D/g, '');
  return cleanedValue.replace(/(\d{2})(\d{2})/, '$1:$2');
};
export const UnmaskTime = (value: string) => {
  return value.replace(':', '');
};
export const validateTime = (value: string) => {
  const unmasked = UnmaskTime(value);
  if (unmasked.length !== 4) {
    return false;
  }
  const hours = parseInt(unmasked.slice(0, 2), 10);
  const minutes = parseInt(unmasked.slice(2, 4), 10);

  return hours >= 0 && hours < 24 && minutes >= 0 && minutes < 60;
};

export const getValidationCreateSchema = () =>
  zod.object({
    time: zod
      .string({
        required_error: 'Campo obrigatório',
      })
      .refine((value) => !!value, {
        message: 'Campo obrigatório',
      })
      .refine((value) => validateTime(value), {
        message: 'Horário inválido',
      }),
  });
